import { useEffect } from "react";
import { useSelector } from "react-redux";
import parse from "html-react-parser";
import { HomeOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Breadcrumb } from "antd";
import "./privacy.scss";

function TermsAndconditions({ t }) {
  const { metaData, currentLang } = useSelector((state) => state?.user);
  useEffect(() => {
    const body = document.querySelector("#root");
    body?.scrollIntoView({
      behavior: "smooth",
    });
  }, []);
  return (
    <>
      <div className="privacy_policy_page">
        <div className="container">
          <div className="header-first">
            <Breadcrumb separator=">">
              <Breadcrumb.Item>
                <Link to="/home">
                  <HomeOutlined />
                  <p className="link-name">الرئيسية</p>
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item className="last-bread">
                الشروط والأحكام
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <div className="privacy_policy_holder">
            <div className="card">
              <p className="card_body">
                {currentLang === "en"
                  ? parse(metaData?.TermsConditions?.Description || "")
                  : parse(metaData?.TermsConditions?.DescriptionLT || "")}
              </p>
            </div>
          </div>
        </div>
      </div>
      ;
    </>
  );
}

export default TermsAndconditions;
